import { useState, useEffect, useCallback } from "react";
import { FileService } from "../../../services/SubmissionService";
import * as APIModels from "../../../models";
import pdfIcon from "../../../assets/images/file-icons/pdf.svg";
import zipIcon from "../../../assets/images/file-icons/zip.svg";
import Select, { ActionMeta } from "react-select";
import { useDropzone } from "react-dropzone";
import { formatBytes } from "../../../helpers/utility";
import React from "react";
import { setRef } from "@material-ui/core";
import moment from "moment";
import {
    ErrorModal,
    ErrorModalProps,
} from "../../../components/shared/modals/ErrorModal";
import { resolve } from "path";
import { Endpoints } from "../../../helpers/Endpoints";

type NameValueOptionType = { label: string; value: string };

export default function AttachExhibits({
    callback,
}: {
    callback: (exhibits: APIModels.Exhibits) => void;
}) {
    const [loading, setLoading] = useState(false);

    const attachmentNameValues: NameValueOptionType[] = [
        {
            label: "File as Separate Document",
            value: "0",
        },
        {
            label: "Merge to Lead Document",
            value: "1",
        },
    ];

    const seperatorNameValues: NameValueOptionType[] = [
        {
            label: "None",
            value: "0",
        },
        {
            label: "Numbers",
            value: "1",
        },
        {
            label: "Letters",
            value: "2",
        },
    ];

    const f: APIModels.FileInfo[] = [];
    const [files, setFiles] = useState(f);

    const [seperatorId, setSeperatorId] = useState("0");
    const [seperatorOptions, setSeperatorOptions] =
        useState(seperatorNameValues);

    const [attachmentTypeId, setAttachmentTypeId] = useState("0");
    const [attachmentOptions, setAttachmentOptions] =
        useState(attachmentNameValues);

    const [errorMessage, setErrorMessage] = useState("");
    const [show, setShow] = useState(false);

    const filenameRegex = /[^a-zA-Z0-9_-]+/g;

    const onCloseErrorModal = () => {
        setShow(false);
        setErrorMessage("");
        setErrorModalProps({
            onClose: onCloseErrorModal,
        } as ErrorModalProps);

        // refresh the page
        // setRefresh(true);
    };

    const [errorModalProps, setErrorModalProps] = useState({
        errorMessage: "",
        onClose: onCloseErrorModal,
    } as ErrorModalProps);

    useEffect(() => {
        if (errorMessage !== "") {
            setErrorModalProps({
                ...errorModalProps,
                errorMessage: errorMessage,
            });
            setShow(true);
        } else {
            setShow(false);
        }
    }, [errorMessage]);

    const onDrop = useCallback(
        (acceptedFiles) => {
            const filInfo = [...files];
            const temp = [] as APIModels.FileInfo[];
            acceptedFiles.forEach((file: any) => {
                // ensure that the file is a *.pdf
                //    otherwise, display an error modal

                if (!file.name.toLowerCase().endsWith(".pdf")) {
                    setErrorMessage("Invalid File Type. Please Upload a PDF.");
                    return;
                }
                const sanatizedName =
                    file.name
                        .toLowerCase()
                        .split(".pdf")[0]
                        .replace(filenameRegex, "") + ".pdf";

                FileService.upload({
                    fileServiceUrl: Endpoints.FileManager,
                    file: file,
                    filename: "uploads/exhibits/" + sanatizedName,
                }).then(
                    (resp) => {
                        resp.text().then((text) => console.log(text));
                        temp.push({
                            filename: sanatizedName,
                            size: file.size,
                            lastUpdatedDateTime: new Date(Date.now()),
                        });
                        setFiles([...files, ...temp]);
                    },
                    (error) => {
                        setErrorMessage(error.message);
                    }
                );
            });
        },
        [files]
    );

    /*
    const onDrop = useCallback((acceptedFiles) => {
        setLoading(true);

        acceptedFiles.forEach((file: any) => {
            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: file,
                filename: "uploads/exhibits/" + file.name,
            }).then(
                (resp) => {
                    setLoading(false);

                    setFiles([
                        ...files,
                        {
                            filename: file.name,
                            size: file.size,
                            lastUpdatedDateTime: new Date(Date.now()),
                        },
                    ]);
                    console.log(resp);
                    resp.text().then((text) => console.log(text));
                },
                (error) => {
                    setLoading(false);
                    console.log(error);
                    setErrorMessage(error);
                }
            );
        });
    }, []);
*/

    const onDropRejected = useCallback((error) => {
        const message = error[0].errors[0].message + ".\n" + error[0].file.path;

        const message2 = setErrorMessage(message); //g + error[0].file.path;
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        maxSize: 35000000,
        accept: "application/pdf",
        multiple: true,
        onDropRejected,
    });

    const onAttachmentOptionChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setAttachmentTypeId(value!.value);
    };

    const onSeperatorChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setSeperatorId(value!.value);
    };

    /*
    const onFileUpload = (event: React.FormEvent) => {
        event.preventDefault();
        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }
        setLoading(true);
        const temp = [...files];
        for (let i = 0; i < input.files.length; i++) {
            const f = input.files[i];

            if (!f.name.endsWith(".pdf")) {
                setErrorMessage("Invalid File Type. Please Upload a PDF");
                return;
            }

            FileService.upload({
                fileServiceUrl: Endpoints.FileManager,
                file: f,
                filename: "uploads/exhibits/" + f.name,
            }).then(
                (resp) => {
                    setLoading(false);

                    temp.push({
                        filename: f.name,
                        size: f.size,
                        lastUpdatedDateTime: new Date(Date.now()),
                    });
                    setFiles([...files, ...temp]);

                    console.log(resp);
                    input.value = "";
                },
                (error) => {
                    setLoading(false);
                    console.log(error);
                    setErrorMessage(error);
                    input.value = "";
                }
            );
        }
    };
    */

    const onFileUpload = useCallback(
        (event: React.FormEvent) => {
            event.preventDefault();
            const input = event.target as HTMLInputElement;

            if (!input.files?.length) {
                return;
            }
            setLoading(true);
            const temp = [] as APIModels.FileInfo[];

            for (let i = 0; i < input.files.length; i++) {
                const f = input.files[i];

                if (!f.name.toLowerCase().endsWith(".pdf")) {
                    setErrorMessage("Invalid File Type. Please Upload a PDF");
                    return;
                }
                const sanatizedName =
                    f.name
                        .toLowerCase()
                        .split(".pdf")[0]
                        .replace(filenameRegex, "") + ".pdf";

                FileService.upload({
                    fileServiceUrl: Endpoints.FileManager,
                    file: f,
                    filename: "uploads/exhibits/" + sanatizedName,
                }).then(
                    (resp) => {
                        setLoading(false);
                        temp.push({
                            filename: sanatizedName,
                            size: f.size,
                            lastUpdatedDateTime: new Date(Date.now()),
                        });
                        setFiles([...files, ...temp]);
                        /*
                        setFiles([
                            ...files,
                            {
                                filename: f.name,
                                size: f.size,
                                lastUpdatedDateTime: new Date(Date.now()),
                            },
                        ]);
                        */
                        console.log(resp);
                        input.value = "";
                    },
                    (error) => {
                        setLoading(false);
                        console.log(error);
                        setErrorMessage(error);
                        input.value = "";
                    }
                );
            }
        },
        [files]
    );

    useEffect(() => {
        callback({
            seperatorOptionKey: parseInt(seperatorId),
            attachmentOptionKey: parseInt(attachmentTypeId),
            filenames: files.map((v, i) => v.filename ?? ""),
        });
    }, [files, seperatorId, attachmentTypeId]);

    const onDelete = (file: APIModels.FileInfo) => {
        setLoading(true);
        if (file.filename) {
            FileService.delete({ filename: file.filename }).then(
                (resp) => {
                    if (resp.successful) {
                        const temp = [...files];
                        temp.splice(temp.indexOf(file), 1);
                        setFiles(temp);
                        console.log(resp);
                        setLoading(false);
                    }
                },
                (error) => {
                    setLoading(false);
                    console.log(error);
                    setErrorMessage(error);
                }
            );
        }
    };

    const filterOption = (
        option: NameValueOptionType,
        inputValue: string
    ): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <div className="card-body">
            {show && <ErrorModal {...errorModalProps} />}
            <h4 className="header-title">Exhibit Upload</h4>
            <p className="sub-header">
                Drop exhibits in the area below to add them to the submission.
            </p>
            <div className="row">
                <div className="col-4 ">
                    <label htmlFor="selSeperator" className="form-label">
                        Exhibit Separater
                    </label>
                    <Select
                        id="selSeperator"
                        name="selSeperator"
                        value={seperatorOptions.filter(
                            (c) => c.value === seperatorId
                        )}
                        filterOption={filterOption}
                        options={seperatorOptions}
                        onChange={onSeperatorChange}
                    />
                </div>
                <div className="col-4">
                    <label htmlFor="selAttachment" className="form-label">
                        Exhibit Attachment Options
                    </label>
                    <Select
                        id="selAttachment"
                        name="selAttachment"
                        value={attachmentOptions.filter(
                            (c) => c.value === attachmentTypeId
                        )}
                        filterOption={filterOption}
                        options={attachmentOptions}
                        onChange={onAttachmentOptionChange}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <div {...getRootProps({ className: "dropzone card-body" })}>
                        <input {...getInputProps()} />

                        <div className="fileupload btn btn-success waves-effect waves-light mb-3">
                            <span>
                                <i className="mdi mdi-cloud-upload me-1"></i>{" "}
                                Upload Files
                            </span>
                            <input
                                type="file"
                                className="upload"
                                onChange={(event) => {
                                    onFileUpload(event);
                                }}
                                multiple
                            />
                        </div>

                        <div>* 35 MB Maximum Upload Size</div>
                        <div
                            className="table-responsive"
                            style={{ overflow: "visible" }}
                        >
                            <table
                                className="table table-centered  table-nowrap mb-0"
                                style={{ zIndex: 0 }}
                            >
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col">File Name</th>
                                        <th scope="col">Date Modified</th>
                                        <th scope="col">Size</th>
                                        <th
                                            scope="col"
                                            className="text-center"
                                            style={{ width: 125 }}
                                        >
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {files.map((file, i) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <img
                                                        src={
                                                            file.filename &&
                                                            file.filename
                                                                .toLowerCase()
                                                                .endsWith(
                                                                    ".pdf"
                                                                )
                                                                ? pdfIcon
                                                                : zipIcon
                                                        }
                                                        height="30"
                                                        alt="icon"
                                                        className="me-2"
                                                    />
                                                    <a
                                                        href="javascript:void(0);"
                                                        className="text-dark"
                                                    >
                                                        {file.filename}
                                                    </a>
                                                </td>
                                                <td className="font-13">
                                                    {file.lastUpdatedDateTime?.toISOString()}
                                                </td>
                                                <td>
                                                    {formatBytes(
                                                        file.size ?? 0
                                                    )}
                                                </td>
                                                {file.lastUpdatedDateTime ? (
                                                    <td>
                                                        <ul
                                                            className="list-inline table-action m-0"
                                                            style={{
                                                                display:
                                                                    "inline-block",
                                                            }}
                                                        >
                                                            <li className="list-inline-item">
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="action-icon px-1"
                                                                    onClick={() => {
                                                                        onDelete(
                                                                            file
                                                                        );
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    <i className="mdi mdi-delete"></i>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                ) : (
                                                    <td>
                                                        {" "}
                                                        <div
                                                            className="spinner-border text-primary m-1"
                                                            role="status"
                                                        >
                                                            <span className="visually-hidden">
                                                                Loading...
                                                            </span>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
